"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingInterval = void 0;
exports.BillingInterval2String = BillingInterval2String;
var BillingInterval;
(function (BillingInterval) {
    BillingInterval["MONTHLY"] = "month";
    BillingInterval["YEARLY"] = "year";
    BillingInterval["DAILY"] = "day";
    BillingInterval["WEEKLY"] = "weekly";
})(BillingInterval || (exports.BillingInterval = BillingInterval = {}));
function BillingInterval2String(interval) {
    switch (interval) {
        case BillingInterval.MONTHLY:
            return "monthly";
        case BillingInterval.YEARLY:
            return "yearly";
        case BillingInterval.DAILY:
            return "daily";
        case BillingInterval.WEEKLY:
            return "weekly";
    }
}
